var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1099"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1099"
    },
    "bundlingPackage": "feedback-public-submission-ui",
    "bundlingPackageVersion": "static-1.29882",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};